import script from "./StatsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatsPage.vue?vue&type=script&setup=true&lang=ts"

import "./StatsPage.vue?vue&type=style&index=0&id=31ee5886&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31ee5886"]])

export default __exports__